export function CptCodePill({ code }: { code: string }) {
  return (
    <span
      className="inline-block text-sm font-semibold px-2 py-1 border-round-lg white-space-nowrap"
      style={{
        background:
          "color-mix(in srgb, var(--brand-purple-700) 5%, var(--blue-50))",
        color:
          "color-mix(in srgb, var(--brand-purple-700) 65%, var(--blue-900))",
      }}
    >
      {code}
    </span>
  );
}
